import { render, staticRenderFns } from "./offineCardLog.vue?vue&type=template&id=4b8a1ab0&scoped=true&"
import script from "./offineCardLog.vue?vue&type=script&lang=js&"
export * from "./offineCardLog.vue?vue&type=script&lang=js&"
import style0 from "./offineCardLog.vue?vue&type=style&index=0&id=4b8a1ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a1ab0",
  null
  
)

export default component.exports